const Syllabus = () => {
    return (
        <>
            {/* <p className='Help__Title'>Ver temarios</p>
            <img src='/img/support/help/instructor/syllabus/1.png' className='Help__Image' />
            <p>¿Cómo funcionan los temarios?</p>
            <p>Permite al instructor consultar los temarios de los cursos activos en el centro. Cada curso está organizado en bloques de conocimiento, y cada bloque contiene temas. A su vez, cada tema incluye instrumentos de aprendizaje como Teoría, Cuestionario, Video y Desafío, además de una actividad por bloque.</p>
            <p>Esta vista ofrece una estructura clara para que el instructor pueda guiar a los Ztudiantes en su proceso formativo y planificar las evaluaciones y actividades de manera efectiva.</p>
            <p>Accede para revisar la organización del curso y garantizar una experiencia de aprendizaje completa.</p> */}
        </>
    )
}

export { Syllabus };